import * as React from 'react';
export const squarespaceSvg = React.forwardRef(function squarespaceSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm9.022 16.338 7.583-7.654a2.7 2.7 0 0 1 1.932-.806c.73 0 1.416.286 1.93.806l.591.596 1.182-1.193-.59-.596a4.352 4.352 0 0 0-3.114-1.3 4.352 4.352 0 0 0-3.112 1.3L7.84 15.145l1.182 1.193Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm19.168 11.226-1.188-1.191-7.619 7.643a2.741 2.741 0 0 1-3.88 0 2.762 2.762 0 0 1 0-3.893l6.574-6.594L11.868 6l-6.574 6.594a4.452 4.452 0 0 0 0 6.275 4.386 4.386 0 0 0 3.127 1.298 4.388 4.388 0 0 0 3.128-1.298l7.619-7.643Zm7.538 1.432a4.384 4.384 0 0 0-3.127-1.298 4.386 4.386 0 0 0-3.128 1.298l-7.619 7.643 1.187 1.19 7.62-7.642a2.741 2.741 0 0 1 4.682 1.946c0 .736-.285 1.428-.802 1.946l-6.574 6.595 1.187 1.191 6.574-6.594a4.451 4.451 0 0 0 0-6.275Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm22.978 15.19-7.583 7.653a2.716 2.716 0 0 1-3.862 0l-.591-.596L9.76 23.44l.59.596c.83.838 1.936 1.3 3.114 1.3a4.352 4.352 0 0 0 3.113-1.3l7.583-7.654-1.182-1.193Z',
      fill: '#fff',
    }),
  );
});
squarespaceSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var squarespace = {
  category: 'brand',
  colorable: false,
  name: 'squarespace',
  svg: squarespaceSvg,
};
